import React, { useState, useEffect } from 'react'
import {
	wheelCollaboratorTranslate,
	personalInfoTranslate,
	employeeExperienceTranslate,
	modalAssignTranslate,
} from '../../../../i18n/translatedMessages'
import { translate } from '../../../../i18n/Library/industry_type'
import { AiOutlineDelete, AiOutlineCheckCircle } from 'react-icons/ai'
import { FormattedMessage, useIntl } from 'react-intl'
import { getIndustryTypeList } from '../../../../API/Lists/industryType'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

const FormProfInfo = ({ data, index, handleChange, deleteProfInfo, updateProfInfo, handleSend, changed }) => {
	const intl = useIntl()
	const language = intl.locale === 'PT-BR' ? 'pt' : 'es'
	const { id, company, job, industryTypeId, startDate, endDate, currentJob, functions, achievements } = data
	const [industryList, setIndustryList] = useState([])
	const [industryOpen, setIndustryOpen] = useState(false)
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

	useEffect(() => {
		const requests = async () => {
			setIndustryList(await getIndustryTypeList())
		}
		requests()
	}, [])

	const handleCheckbox = e => {
		const event = {
			...e,
			currentTarget: {
				...e.currentTarget,
				name: 'currentJob',
				checked: e.target.checked,
				value: e.target.checked,
			},
		}
		handleChange(index, event)
	}

	const handleDeleteClick = e => {
		e.preventDefault()
		setShowDeleteConfirm(true)
	}

	const handleDeleteConfirm = e => {
		setShowDeleteConfirm(false)
		deleteProfInfo(index, e)
	}

	const handleDeleteCancel = () => {
		setShowDeleteConfirm(false)
	}

	return (
		<>
			<div className='container formProfInfo-main'>
				<div className='row'>
					<div className='col-md-4'>
						<div className='mb-3'>
							<label htmlFor={`formProfInfo-input1-` + id} className='form-label'>
								{employeeExperienceTranslate.historicProfessionalEENameCompany}
							</label>
							<div className='tw-w-full border border-grey tw-rounded-md px-1 tw-flex tw-items-center tw-justify-center'>
								<input
									type='text'
									className='border-0 p-0 m-0 ms-2 tw-w-full'
									id={`formProfInfo-input1-` + id}
									placeholder=''
									name='company'
									value={company}
									onChange={e => handleChange(index, e)}
								/>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<div className='mb-3'>
							<label htmlFor='formProfInfo-select1' className='form-label'>
								{employeeExperienceTranslate.historicProfessionalEEAreaCompany}
							</label>
							<div
								className={`tw-relative tw-w-full border border-grey tw-rounded-lg px-1 tw-flex tw-items-center  ${
									!industryTypeId || industryTypeId === '0' ? 'tw-text-gray-400' : ''
								}`}
								style={{ minHeight: 38, cursor: 'pointer' }}
								onClick={() => setIndustryOpen(v => !v)}
							>
								<select
									className='border-0 p-0 m-0 ms-2 tw-w-full tw-outline-none tw-appearance-none'
									id='formProfInfo-select1'
									aria-label='Default select example'
									name='industryTypeId'
									value={industryTypeId}
									onChange={e => handleChange(index, e)}
									style={{ cursor: 'pointer' }}
								>
									<option value={0}>{intl.formatMessage({ id: 'historicProfessionalEEOption0' })}</option>
									{industryList.map((ind, key) => (
										<option key={key} value={ind.id}>
											{translate[language][ind.name]}
										</option>
									))}
								</select>
								<span className='tw-absolute tw-right-3 tw-pointer-events-none'>
									{industryOpen ? <MdKeyboardArrowUp size={20} /> : <MdKeyboardArrowDown size={20} />}
								</span>
							</div>
						</div>
					</div>

					<div className='col-md-4'>
						<label htmlFor={`formProfInfo-input2-` + id} className='form-label'>
							{employeeExperienceTranslate.historicProfessionalEEJob}
						</label>
						<div className='tw-w-full border border-grey tw-rounded-md px-1 tw-flex tw-items-center tw-justify-center'>
							<input
								type='text'
								className='border-0 p-0 m-0 ms-2 tw-w-full'
								id={`formProfInfo-input2-` + id}
								placeholder=''
								aria-label='cargo'
								name='job'
								value={job}
								onChange={e => handleChange(index, e)}
							/>
						</div>
					</div>

					<div className='col-md-4'>
						<div className='mb-3'>
							<label className='form-label'>{personalInfoTranslate.personalEntryDate}</label>
							<input
								type='date'
								className='form-control'
								name='startDate'
								value={startDate ? startDate.substring(0, 10) : ''}
								onChange={e => handleChange(index, e)}
							/>
						</div>
					</div>

					<div className='col-md-4'>
						<div className='mb-3'>
							<label className='form-label'>{personalInfoTranslate.personalExitDate}</label>
							<input
								type='date'
								className='form-control'
								name='endDate'
								value={endDate ? endDate.substring(0, 10) : ''}
								onChange={e => handleChange(index, e)}
								disabled={currentJob}
							/>
						</div>
					</div>

					<div className='col-md-4'>
						<div className='tw-flex tw-items-center tw-h-full'>
							<input
								className='ms-2 tw-text-purple-500 tw-bg-purple-100 tw-border-purple-500 focus:tw-ring-purple-500 focus:tw-border-purple-500'
								type='checkbox'
								name='currentJob'
								id={`formProfInfo-check-` + id}
								onChange={handleCheckbox}
								checked={!!currentJob}
								style={{ marginTop: 0, marginBottom: 0 }}
							/>
							<label className='form-check-label ms-2 tw-align-middle' htmlFor={`formProfInfo-check-` + id} style={{ marginBottom: 0 }}>
								{personalInfoTranslate.personalHastaFecha}
							</label>
						</div>
					</div>
				</div>

				<div className='row pt-4'>
					<div className='col-md-6'>
						<div className='mb-3'>
							<label htmlFor={`functions-` + id} className='form-label'>
								{wheelCollaboratorTranslate.functionsTitle}
							</label>
							<textarea
								cols='10'
								rows='6'
								className='form-control m-0'
								id={`functions-` + id}
								placeholder=''
								name='functions'
								value={functions}
								onChange={e => handleChange(index, e)}
							></textarea>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='mb-3'>
							<label htmlFor={`achievements-` + id} className='form-label'>
								{wheelCollaboratorTranslate.achievementsTitle}
							</label>
							<textarea
								cols='10'
								rows='6'
								className='form-control m-0'
								id={`achievements-` + id}
								placeholder=''
								name='achievements'
								value={achievements}
								onChange={e => handleChange(index, e)}
							></textarea>
						</div>
					</div>
				</div>

				<div className='row justify-content-end text-end pt-4'>
					<div className='col-auto'>
						<button
							data-expid={data.id}
							className='tw-bg-white hover:tw-bg-gray-50 tw-text-gray-700 tw-px-4 tw-py-2 tw-rounded-lg d-flex align-items-center border'
							onClick={handleDeleteClick}
						>
							Eliminar <AiOutlineDelete size={22} className='ms-2' />
						</button>
					</div>
					<div className='col-auto'>
						<button
							data-expid={data.id}
							className='tw-bg-purple-500 hover:tw-bg-purple-800 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg tw-ml-2 d-flex align-items-center border-0'
							onClick={id ? e => updateProfInfo(index, e) : () => handleSend()}
							disabled={!changed}
							style={{ pointerEvents: !changed ? 'none' : 'auto' }}
						>
							{modalAssignTranslate.btnSave} <AiOutlineCheckCircle size={22} className='ms-2' />
						</button>
					</div>
				</div>

				{showDeleteConfirm && (
					<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50'>
						<div className='tw-bg-white tw-rounded-lg tw-p-6 tw-shadow-lg tw-max-w-xs tw-w-full'>
							<p className='tw-mb-4'>¿Estás seguro de que deseas eliminar esta experiencia?</p>
							<div className='tw-flex tw-justify-end tw-gap-2'>
								<button
									className='tw-bg-gray-200 hover:tw-bg-gray-300 tw-text-gray-800 tw-px-4 tw-py-2 tw-rounded border-0'
									onClick={handleDeleteCancel}
								>
									Cerrar
								</button>
								<button
									className='tw-bg-error-600 hover:tw-bg-error-800 tw-text-white tw-px-4 tw-py-2 tw-rounded border-0'
									onClick={handleDeleteConfirm}
								>
									Confirmar
								</button>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	)
}

export default FormProfInfo
